export default __webpack_public_path__ + "static/media/brakekit-small-turquoise.02b0622b.webp";